// import { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import styles from './Auth.module.css';
// import { useNavigate } from 'react-router-dom';
// import { useLoginUserMutation } from "../../store/api/authApi.js";
// import Logo from '../../components/Logo.jsx';
// import { useDispatch } from 'react-redux';
// import { login as loginAction } from '../../store/authSlice';
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// const Login = () => {
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [error, setError] = useState('');
//   const location = useLocation();
//   const from = location.state?.from?.pathname || null;
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loginUser, { isLoading }] = useLoginUserMutation();
//   const [showPassword, setShowPassword] = useState(false);

//   const validateForm = () => {
//     if (!formData.email) { setError("Email is required"); return false; }
//     if (!/\S+@\S+\.\S+/.test(formData.email)) { setError("Please enter a valid email address"); return false; }
//     if (!formData.password) { setError("Password is required"); return false; }
//     const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
//     if (!strongPasswordRegex.test(formData.password)) {
//       setError("Password must be at least 8 characters and include uppercase, lowercase, number, and special character.");
//       return false;
//     }
//     return true;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setError('');
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setError('');
//     try {
//       const response = await loginUser(formData).unwrap();
//       const profileComplete = response.profileCompleted ?? response.profileComplete ?? false;
//       dispatch(loginAction({ token: response.token, userId: response.userId, profileComplete }));
//       if (profileComplete) {
//         navigate(from || "/home", { replace: true });
//       } else {
//         navigate('/user-details');
//       }
//     } catch (err) {
//       if (err?.status === 401 || err?.response?.status === 401) {
//         setError("Invalid email or password. Please try again.");
//         return;
//       }
//       const msg = err.response?.data?.message || err.message || 'Something went wrong. Please try again.';
//       setError(msg);
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.card}>

//         {/* ── Left branding panel ── */}
//         <div className={styles.brandPanel}>
//           <div className={styles.brandInner}>
//               <Logo height={140} scale={3} onClick={() => navigate("/")}/>
//             <p className={styles.brandTagline}>
//               Bridge the gap. Build the future.
//             </p>
//           </div>
//         </div>
//         {/* ── Right form panel ── */}
//         <div className={styles.formPanel}>
//           <div className={styles.formInner}>
//             <div className={styles.formHeader}>
//               <h2 className={styles.heading}>Welcome Back</h2>
//               <p className={styles.subheading}>Sign in to continue to Nessefy</p>
//             </div>

//             {error && <p className={styles.error}>{error}</p>}

//             <form onSubmit={handleSubmit} className={styles.form} noValidate>
//               <div className={styles.formGroup}>

//                 <div className={styles.fieldGroup}>
//                   <label className={styles.label} htmlFor="email">Email Address</label>
//                   <input
//                     id="email"
//                     type="email"
//                     name="email"
//                     placeholder="Enter your email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     className={styles.input}
//                   />
//                 </div>

//                 <div className={styles.fieldGroup}>
//                   <label className={styles.label} htmlFor="password">Password</label>
//                   <div className={styles.passwordWrapper}>
//                     <input
//                       id="password"
//                       type={showPassword ? "text" : "password"}
//                       name="password"
//                       placeholder="Enter your password"
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                       className={styles.input}
//                     />
//                     <span className={styles.eyeIcon} onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </span>
//                   </div>
//                 </div>

//                 <div className={styles.forgotRow}>
//                   <Link to="/forgot-password" className={styles.link}>Forgot password?</Link>
//                 </div>

//                 <button type="submit" className={styles.button} disabled={isLoading}>
//                   {isLoading ? 'Signing in…' : 'Sign In'}
//                 </button>
//               </div>
//             </form>

//             <div className={styles.dividerRow}>
//               <span className={styles.dividerLine} />
//               <span className={styles.dividerText}>or</span>
//               <span className={styles.dividerLine} />
//             </div>

//             <Link to="/register" className={`${styles.button} ${styles.cabutton}`}>
//               Create an Account
//             </Link>

//             <p className={styles.footerNote}>
//               By signing in, you agree to our{' '}
//               <span className={styles.footerLink}>Terms</span> &{' '}
//               <span className={styles.footerLink}>Privacy Policy</span>
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Auth.module.css';
import r from './Reactivate.module.css';
import { useNavigate } from 'react-router-dom';
import { useLoginUserMutation, useReactivateAccountMutation } from '../../store/api/authApi.js';
import Logo from '../../components/Logo.jsx';
import { useDispatch } from 'react-redux';
import { login as loginAction } from '../../store/authSlice';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

// Helper: backend sends PascalCase { Token, UserId, ProfileCompleted }.
// RTK Query / fetchBaseQuery does NOT auto-camelCase — read both casings.
const readProfile = (res) =>
  res?.ProfileCompleted ?? res?.profileCompleted ?? res?.profileComplete ?? false;

const Login = () => {
  const [formData, setFormData]         = useState({ email: '', password: '' });
  const [error, setError]               = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [showReactivate, setShowReactivate]   = useState(false);
  const [reactivating, setReactivating]       = useState(false);
  const [reactivateError, setReactivateError] = useState('');
  const [reactivateDone, setReactivateDone]   = useState(false);

  const location = useLocation();
  const from     = location.state?.from?.pathname || null;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loginUser, { isLoading }] = useLoginUserMutation();
  const [reactivateAccount]        = useReactivateAccountMutation();

  const validateForm = () => {
    if (!formData.email)  { setError('Email is required'); return false; }
    if (!/\S+@\S+\.\S+/.test(formData.email)) { setError('Please enter a valid email address'); return false; }
    if (!formData.password) { setError('Password is required'); return false; }
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!strongPasswordRegex.test(formData.password)) {
      setError('Password must be at least 8 characters and include uppercase, lowercase, number, and special character.');
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError('');
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Backend returns: { Token, UserId, Email, ProfileCompleted }  (PascalCase)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setError('');

    try {
      const res = await loginUser(formData).unwrap();

      const token           = res.Token  ?? res.token;
      const userId          = res.UserId ?? res.userId;
      const profileComplete = readProfile(res);

      dispatch(loginAction({ token, userId, profileComplete }));
      navigate(profileComplete ? (from || '/home') : '/user-details', { replace: true });

    } catch (err) {
      if (err?.data?.canReactivate === true) {
        setShowReactivate(true);
        setError('');
        return;
      }
      if (err?.status === 401) {
        setError('Invalid email or password. Please try again.');
        return;
      }
      setError(err?.data?.message || err?.message || 'Something went wrong. Please try again.');
    }
  };

  // Backend returns: { Token, Email, Id, ProfileCompleted }  (PascalCase)
  const handleReactivate = async () => {
    setReactivateError('');
    if (!formData.email || !formData.password) {
      setReactivateError('Email and password are required.');
      return;
    }

    setReactivating(true);
    try {
      const res = await reactivateAccount({
        email:    formData.email,
        password: formData.password,
      }).unwrap();

      setReactivateDone(true);

      const token           = res.Token  ?? res.token;
      const userId          = res.Id     ?? res.id ?? res.UserId ?? res.userId;
      const profileComplete = readProfile(res);

      setTimeout(() => {
        dispatch(loginAction({ token, userId, profileComplete }));
        navigate(profileComplete ? (from || '/home') : '/user-details', { replace: true });
      }, 1800);

    } catch (err) {
      setReactivateError(err?.data?.message || 'Could not reactivate. Please check your credentials.');
    } finally {
      setReactivating(false);
    }
  };

  const handleCancelReactivate = () => {
    setShowReactivate(false);
    setReactivateError('');
    setReactivateDone(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>

        <div className={styles.brandPanel}>
          <div className={styles.brandInner}>
            <Logo height={140} scale={3} onClick={() => navigate('/')} />
            <p className={styles.brandTagline}>Bridge the gap. Build the future.</p>
          </div>
        </div>

        <div className={styles.formPanel}>
          <div className={styles.formInner}>

            {showReactivate ? (
              <div className={r.panel}>

                <div className={r.iconWrap}>
                  <svg className={r.sleepIcon} viewBox="0 0 48 48" fill="none">
                    <circle cx="24" cy="24" r="23" stroke="#016d9c" strokeWidth="2" strokeDasharray="4 3" opacity="0.25"/>
                    <circle cx="24" cy="24" r="18" fill="#eef6fb"/>
                    <path d="M28 16a10 10 0 1 1-12 12 7 7 0 0 0 12-12z" fill="#016d9c" opacity="0.85"/>
                    <text x="30" y="18" className={r.zText} fontSize="5" fill="#fb9833" fontWeight="700" fontFamily="Sora,sans-serif">Z</text>
                    <text x="33" y="13" className={r.zText2} fontSize="4" fill="#fb9833" fontWeight="700" fontFamily="Sora,sans-serif" opacity="0.6">z</text>
                  </svg>
                </div>

                {reactivateDone ? (
                  <div className={r.successState}>
                    <div className={r.successIcon}>
                      <svg viewBox="0 0 40 40" fill="none" width="40" height="40">
                        <circle cx="20" cy="20" r="19" fill="#e1f5ee" stroke="#1d9e75" strokeWidth="1.5"/>
                        <path d="M12 20l6 6 10-12" stroke="#1d9e75" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <h3 className={r.successTitle}>Welcome back!</h3>
                    <p className={r.successSub}>Your account is active again. Redirecting…</p>
                    <div className={r.progressBar}><div className={r.progressFill} /></div>
                  </div>
                ) : (
                  <>
                    <div className={r.heading}>
                      <h2 className={r.title}>Your account is paused</h2>
                      <p className={r.subtitle}>
                        You deactivated this account. All your posts, connections and data are still here — confirm your password to reactivate instantly.
                      </p>
                    </div>

                    <div className={r.waitingCard}>
                      <div className={r.waitingItem}>
                        <span className={r.waitingDot} style={{ background: '#016d9c' }} />
                        <span>Your profile &amp; posts</span>
                      </div>
                      <div className={r.waitingItem}>
                        <span className={r.waitingDot} style={{ background: '#fb9833' }} />
                        <span>All your connections &amp; followers</span>
                      </div>
                      <div className={r.waitingItem}>
                        <span className={r.waitingDot} style={{ background: '#2ecc71' }} />
                        <span>Messages &amp; notifications</span>
                      </div>
                    </div>

                    <div className={r.fieldGroup}>
                      <label className={r.label}>Email</label>
                      <input
                        className={`${r.input} ${r.inputReadonly}`}
                        type="email"
                        value={formData.email}
                        readOnly
                      />
                    </div>

                    <div className={r.fieldGroup}>
                      <label className={r.label}>Password</label>
                      <input
                        className={r.input}
                        type="password"
                        value={formData.password}
                        onChange={(e) => {
                          setReactivateError('');
                          setFormData((p) => ({ ...p, password: e.target.value }));
                        }}
                        placeholder="Enter your password"
                        autoFocus
                      />
                    </div>

                    {reactivateError && <p className={r.error}>{reactivateError}</p>}

                    <button
                      className={r.btnReactivate}
                      onClick={handleReactivate}
                      disabled={reactivating}
                    >
                      {reactivating ? (
                        <span className={r.btnInner}>
                          <span className={r.spinner} /> Reactivating…
                        </span>
                      ) : (
                        '✦ Reactivate My Account'
                      )}
                    </button>

                    <button className={r.btnBack} onClick={handleCancelReactivate}>
                      ← Back to Sign In
                    </button>
                  </>
                )}
              </div>

            ) : (
            <>
              <div className={styles.formHeader}>
                <h2 className={styles.heading}>Welcome Back</h2>
                <p className={styles.subheading}>Sign in to continue to Nessefy</p>
              </div>

              {error && <p className={styles.error}>{error}</p>}

              <form onSubmit={handleSubmit} className={styles.form} noValidate>
                <div className={styles.formGroup}>

                  <div className={styles.fieldGroup}>
                    <label className={styles.label} htmlFor="email">Email Address</label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className={styles.input}
                    />
                  </div>

                  <div className={styles.fieldGroup}>
                    <label className={styles.label} htmlFor="password">Password</label>
                    <div className={styles.passwordWrapper}>
                      <input
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        className={styles.input}
                      />
                      <span className={styles.eyeIcon} onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  <div className={styles.forgotRow}>
                    <Link to="/forgot-password" className={styles.link}>Forgot password?</Link>
                  </div>

                  <button type="submit" className={styles.button} disabled={isLoading}>
                    {isLoading ? 'Signing in…' : 'Sign In'}
                  </button>
                </div>
              </form>

              <div className={styles.dividerRow}>
                <span className={styles.dividerLine} />
                <span className={styles.dividerText}>or</span>
                <span className={styles.dividerLine} />
              </div>

              <Link to="/register" className={`${styles.button} ${styles.cabutton}`}>
                Create an Account
              </Link>

              <p className={styles.footerNote}>
                By signing in, you agree to our{' '}
                <span className={styles.footerLink}>Terms</span> &{' '}
                <span className={styles.footerLink}>Privacy Policy</span>
              </p>
            </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;